export const COLORS = {
  bg: "#0F1520",
  grid: "rgba(255,255,255,0.06)",
  label: "#9CA3AF",
  up: "#22C55E",
  upBorder: "#16A34A",
  down: "#EF4444",
  downBorder: "#DC2626",
  timeBar: "#EF4444",
  crosshair: "rgba(255,255,255,0.35)",
  line: "#3c567e",
} as const;

export const GRID = {
  left: 0,
  right: 20,
  top: 24,
  bottom: 32,
} as const;

export const CANDLE_MIN_WIDTH = 2;
export const RIGHT_PADDING_PERCENT = 0.5;
export const ANIMATION_DURATION = 300;
